import Service from "../../services";
import { checkAndReturn } from "../../main";

const state = {};

const getters = {};

const actions = {
  index({ commit }, params) {
    return Service.UserServiceHistory.index(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  show({ commit }, params) {
    return Service.UserServiceHistory.show(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  save({ commit }, params) {
    return Service.UserServiceHistory.save(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  create({ commit }, params) {
    return Service.UserServiceHistory.create(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  update({ commit }, params) {
    return Service.UserServiceHistory.update(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
